import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { ImpuestosService } from 'src/app/services/impuestos.service';
import { ModalSeleccionarProductoProveedorComponent } from '../../modal-seleccionar-producto/modal-seleccionar-producto/modal-seleccionar-producto-proveedor.component';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import * as _ from 'lodash';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { debounceTime, filter } from 'rxjs/operators';
import { RutService } from 'src/app/shared/services/rut.service';
import { DocumentoService, IFechaVencimientoQueryParams } from '../../../../../services/documento.service';
import { MessageRendererService } from '../../../../../services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { DatesService } from '../../../../../shared/services/dates.service';
import { ThrowStmt } from '@angular/compiler';
import { BodegaService } from 'src/app/services/bodega.service';
import { isThisQuarter } from 'date-fns';
import { ClienteProveedorService } from '../../../../../services/cliente-proveedor.service';
import { DocumentoRecepcionadoService } from '../../../../../services/documento-recepcionado.service';
import { DocumentoRecepcionadoDetalleService } from '../../../../../services/documento-recepcionado-detalle.service';
import { ListaPrecioDetalleService } from '../../../../../services/lista-precio-detalle.service';
@Component({
  selector: 'app-modal-agregar-documento',
  templateUrl: './modal-agregar-documento.component.html',
  styleUrls: ['./modal-agregar-documento.component.scss'],
  providers: [SecurityService],
})
export class ModalAgregarDocumentoComponent implements OnInit {
  // Modales

  @ViewChild(ModalSeleccionarProductoProveedorComponent, { static: true }) modalSeleccionarProduct: ModalSeleccionarProductoProveedorComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @ViewChild('agregarDoc', { static: true })
  agregarDocModal: ModalDirective;

  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onExecuteBuscar: EventEmitter<any> = new EventEmitter<any>();

  // check descuento
  readonly RB_TIPO_PORCENTAJE_DESC: boolean = true;
  readonly RB_TIPO_PESO_DESC: boolean = false;

  // check recargo
  readonly RB_TIPO_PORCENTAJE_REC: boolean = true;
  readonly RB_TIPO_PESO_REC: boolean = false;

  // Constantes
  readonly PRODUCTO_LIBRE_AFECTO: String = '_PRODUCTO_LIBRE_AFECTO';
  readonly PRODUCTO_LIBRE_EXCENTO: String = '_PRODUCTO_LIBRE_EXCENTO';

  productoSeleccionado: any = null;

  // Form
  formHeader: FormGroup;
  formImpuestos: FormGroup;
  formItems: FormGroup;

  // Data & tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rut_usuario: number;

  headerData: any = {};
  NoExisteFolio: boolean = false;
  ImpuestoCod: number = 0;
  cantidadRecibida: number = 0;
  descuentoCod: number = 0;
  RecargoCod: number = 0;
  noExisteProveedor: boolean = false;
  get proveedor() {
    if (!this.headerData) return null;
    return this.headerData.proveedorSeleccionado;
  }
  // Utils
  private log: any;

  impuesto: string = '';
  Montoimpuesto: any;
  nombreImpuesto: string = '';
  disabledTipoFact = false;
  HiddeIvaUseComun = false;
  checkAll: boolean = false;
  checkAllDetalle: boolean = false;
  checkDetail: boolean = false;
  countSelectImp: number = 0;
  countSelectDetalle: number = 0;
  montoTotal: number = 0; //D
  montoImpuestoAdicional: number = 0;
  proveedorSeleccionado: any = null;
  //TOTAL CABECERA
  SubTotal: number = 0;
  DescGbl: number = 0;
  RecargoGbl: number = 0;
  MontoAf: number = 0; //A
  MontoEx: number = 0; //B
  MontoIva: number = 0; //C
  IvaRec: number = 0;
  IvaNoRec: number = 0;
  IvaActF: number = 0;
  IvaRet: number = 0;
  IvaComn: number = 0;
  TotalBruto: number = 0;
  seleccionaRutProveedor: any;
  priceU: number;
  amountInput: number;
  inputDiscount: number;
  inputSurcharge: number;
  taxInput: number;
  totalLine: number = 0;
  showImpuesto: boolean = false;
  showFactor: boolean = false;
  showBodega: boolean = false;
  currentSearchParams: any;
  listaDetalleDoc: any;

  paginationContext: PaginationContext = new PaginationContext();
  arrayGetItems: Array<any> = [];
  loading: boolean = false;
  AddlistaDetalleDocRec: Array<any> = [];
  totalMonto: number = 0;
  detalleNombreItem: any;
  EnableButton: boolean = false;
  folio: number = 0;
  Existefolio: string = '';

  initialValues: any;
  detalleItem: any;

  PrecioUni: number = 0;
  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private impuestosService: ImpuestosService,
    private condicionPagoService: CondicionPagoService,
    private tipodteService: TipoDTEService,
    private rutService: RutService,
    private documentoService: DocumentoService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
    private bodegaService: BodegaService,
    private clienteProveedorService: ClienteProveedorService,
    private documentoRecepcionadoService: DocumentoRecepcionadoService,
    private documentoRecepcionadoDetalleService: DocumentoRecepcionadoDetalleService,
    private listaPrecioDetalleService: ListaPrecioDetalleService
  ) {
    this.log = this.clog.log('DOC-RECIBIDO-MANUAL-MODAL-AGREGAR-DETALLE');
  }

  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  optionsCondPago: Array<any> = [];
  optionsTipoFact: Array<any> = [];
  optionsTipoItem: Array<any> = [];
  optionsUndMed: Array<any> = [];
  optionsSelect: Array<any> = [];
  optionsImp: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsFormatoProductoLibre: Array<any> = [{ value: 'UNID', label: 'Unidad' }];

  //variable for table
  dynamicArray: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();

    this.createFormInitialValues();
    this.createForm();
    this.loadMesesAndAnhos();
    this.loadBodegas();
    this.loadImpuestosAdic();
    this.loadCondicionPago();
    this.loadTipoFactura();
    this.loadTipoItem();
    this.formChangesSubscriptions();
  }

  show() {
    this.agregarDocModal.show();
  }

  loadBodegas() {
    this.changeShowInventario();
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
    };

    this.bodegaService.ObtenerBodegas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({
        value: bodega.codigo,
        label: bodega.nombre,
        ...bodega,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega);
    });
  }

  createFormInitialValues() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    this.initialValues = {
      mesPeriodo: currentMonth,
      gestion: currentYear,
    };
  }

  /********* FORM *********/
  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      // buscarPor: [this.TIPO_NOMBRE, [Validators.required]],
      // nombre_rut: ['', [Validators.required]]
      CondPago: [''],
      tipoFact: [''],
      rutProveedor: [null, [Validators.required]],
      mesPeriodo: [this.initialValues.mesPeriodo, [Validators.required]],
      gestion: [this.initialValues.gestion, [Validators.required]],
      nFolio: [null],
      GlosaN: [''],
      FechaDoc: [currentDate],
      IvaUsoComun: [false],
      EntregaGratuita: [false],
      MontoBrutoDetalle: [false],
      MueveInventario: [true],
      FactorIva: [0],
      bodega: [''],
    });

    this.formImpuestos = this.fb.group({
      impAdic: [null],
    });

    this.formItems = this.fb.group({
      esProductoLibre: [false],
      productoLibre: this.fb.group({
        codigo: ['', [Validators.required, Validators.min(1)]],
        descripcion: ['', [Validators.required]],
        cantidad: [1, [Validators.required, Validators.min(1)]],
        formato: ['UNID', [Validators.required]],
        precioUnitario: [0, [Validators.required, Validators.min(1)]],
        es_exento: [this.PRODUCTO_LIBRE_AFECTO, [Validators.required]],
      }),
      productoExistente: this.fb.group({
        tipoItems: [null],
        codProduct: [null, [Validators.required]],
        formatCode: [null, [Validators.required]],
        impAdic: [null],
        ActivoFijo: [false],
        tipoDesc: [this.RB_TIPO_PORCENTAJE_DESC, [Validators.required]],
        tipoRec: [this.RB_TIPO_PORCENTAJE_REC, [Validators.required]],
        AsigImpuesto: [false, [Validators.required]],
        codCantidad: [null],
        codPrecioU: [null],
        codDescuento: [null],
        codRecargo: [null],
      }),
    });
    this.formItems.get('productoLibre.codigo').disable();
  }

  formChangesSubscriptions() {
    this.formHeader
      .get('rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(2500))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut);
        this.EnableItemAndSave();
      });

    this.formItems
      .get('productoExistente.codProduct')
      .valueChanges.pipe(filter(Boolean))
      .subscribe((codProduct: string) => {
        this.modalSeleccionarProduct.searchByCodeProduct(codProduct);
      });

    this.formHeader
      .get('nFolio')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((folio: number) => {
        this.folio = folio;
        this.EnableItemAndSave();
      });

    this.formImpuestos.get('impAdic').valueChanges.subscribe((TipoImp: Number) => {
      if (TipoImp) {
        this.impuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].codigo;
        this.Montoimpuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].valor;
        this.nombreImpuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].nombre;
      }

      // if (factura) this.handleChangeTipoDocumento(factura)
    });
    this.formHeader.get('FechaDoc').valueChanges.subscribe((fecha) => this.handleFechaFacturaChange(fecha));
    this.formHeader.get('CondPago').valueChanges.subscribe((CondPago) => {
      if (!CondPago) {
        this.log('condicionPago change', CondPago);
        if (this.headerData && this.headerData.fechaVencimiento) this.headerData.fechaVencimiento = null;
      } else {
        this.fetchFechaVencimiento();
      }
    });
    this.formHeader.get('tipoFact').setValue(33);
  }

  loadMesesAndAnhos() {
    this.optionsMonth = this.datesService.GetMonths();
    this.optionsYear = this.datesService.GetRangeYears();
  }

  private loadImpuestosAdic() {
    this.impuestosService.obtenerImpuestos(({ respuesta }) => {
      const { registros } = respuesta;

      this.optionsSelect = registros.map((imp) => ({
        value: imp.codigo,
        label: imp.nombre,
        ...imp,
      }));
      // this.formValidatorsService.selectFirstOrDefault(this.formImpuestos.get('impAdic'), this.optionsSelect)
    });
  }

  loadCondicionPago() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
      },
    };
    this.condicionPagoService.obtenerCondicionPagoCompra(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsCondPago = registros.map((cond) => ({
        value: cond.codigo,
        label: cond.descripcion,
        ...cond,
      }));

      console.log(this.optionsCondPago);
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('CondPago'), this.optionsCondPago);
    });
  }

  loadTipoFactura() {
    this.tipodteService.obtenerTipoCompraRecepcionDoc(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoFact = registros.map((fact) => ({
        value: fact.codigo,
        label: fact.nombre,
        ...fact,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoFact'), this.optionsTipoFact);
    });
  }

  loadTipoItem() {
    const inputParams = {
      entidad: {
        nombre: '',
        activo: true,
      },
    };
    this.tipodteService.obtenerTipoItem(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;

      this.optionsTipoItem = registros.map((item) => ({
        value: item.codigo,
        label: item.nombre,
        ...item,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formItems.get('productoExistente.tipoItems'), this.optionsTipoItem);
    });
  }

  OpenSelectProduct() {
    const folio = this.formHeader.get('nFolio').value;
    const proveedor = this.formHeader.get('rutProveedor').value;

    if (folio === null || folio === '') {
      this.NoExisteFolio = true;
      if (this.NoExisteFolio === true) {
        this.toastService.warning('Ingrese Folio');
        return;
      }
    } else {
      this.NoExisteFolio = false;

      if (proveedor === null || proveedor === '') {
        this.toastService.warning('Ingrese el rut de proveedor');
        this.noExisteProveedor = true;
        return;
      } else {
        this.noExisteProveedor = false;
      }
    }

    this.modalSeleccionarProduct.show();
  }

  changeShowImpuesto() {
    if (this.formItems.get('productoExistente.AsigImpuesto').value === true) {
      this.showImpuesto = true;
    } else {
      this.showImpuesto = false;
    }
  }

  changeShowFactor() {
    if (this.formHeader.get('IvaUsoComun').value === true) {
      this.showFactor = true;
    } else {
      this.showFactor = false;
    }
  }

  changeShowInventario() {
    if (this.formHeader.get('MueveInventario').value === true) {
      this.showBodega = true;
    } else {
      this.showBodega = false;
    }
  }

  OnAddImpuestoAd() {
    const params = {
      codigo: this.impuesto,
      detalle: this.nombreImpuesto,
      valor: this.Montoimpuesto,
      index: this.impuesto,
      checked: false,
    };

    this.dynamicArray.push(params);

    const PorcentajeImpuestoAdic = _.sumBy(this.dynamicArray, 'valor') / 100;
    this.montoImpuestoAdicional = this.MontoAf * PorcentajeImpuestoAdic;
    //OBTENER MONTO TOTAL
    this.montoTotal = _.sumBy(this.dynamicArray, 'valor');
    console.log(this.MontoIva, this.MontoAf, this.MontoEx, this.montoTotal);
    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  checkAllChange({ checked }) {
    this.dynamicArray.forEach((detalle) => {
      detalle.checked = checked;
    });
    //SELECCIONAR TODO
    this.checkAll = checked;

    //ELEMENTOS SELECCIONADOS
    this.countSelectImp = this.dynamicArray.filter((x) => x.checked === true).length;
  }

  checkDetalle({ index }, { checked }) {
    this.dynamicArray.map((detalle) => {
      if (detalle.codigo === index) {
        detalle.checked = checked;
      }
    });

    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.dynamicArray.filter((detalle: any) => !detalle.checked).length;
    this.checkAll = totalUnselected === 0;

    //SUMA DE ELEMENTOS SELECCIONADOS
    this.countSelectImp = this.dynamicArray.filter((x) => x.checked === true).length;
  }

  OnDeleteDetail() {
    var atleastOneSelected = this.dynamicArray.filter((checkbox) => checkbox.checked === true);

    if (atleastOneSelected.length === 0) {
      this.countSelectImp = 0;
      this.toastService.error('No existen registros para eliminar');
      return;
    }

    var UnSelectData = this.dynamicArray.filter((checkbox) => checkbox.checked === false);
    this.dynamicArray = UnSelectData;

    if (this.checkAll === true) {
      this.countSelectImp = 0;
    }

    this.checkAll = false;
    //SUMA DE ELEMENTOS NO SELECCIONADOS
    this.montoTotal = _.sumBy(this.dynamicArray, 'valor');
    const PorcentajeImpuestoAdic = _.sumBy(this.dynamicArray, 'valor') / 100;
    this.montoImpuestoAdicional = this.MontoAf * PorcentajeImpuestoAdic;
    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  OnChangeTotalxIva(iva) {
    this.MontoIva = parseInt(iva);

    if (iva === '') {
      this.MontoIva = 0;
    }

    if (!this.MontoAf) {
      this.MontoAf = 0;
    }
    if (!this.MontoEx) {
      this.MontoEx = 0;
    }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  OnChangeTotalxAfecto(afecto) {
    this.MontoAf = parseInt(afecto);

    if (afecto === '') {
      this.MontoAf = 0;
    }

    if (!this.MontoIva) {
      this.MontoIva = 0;
    }
    if (!this.MontoEx) {
      this.MontoEx = 0;
    }

    this.fetchMontoIVA(this.MontoAf);
  }

  OnChangeTotalxExento(exento) {
    this.MontoEx = parseInt(exento);

    if (exento === '') {
      this.MontoEx = 0;
    }

    if (!this.MontoIva) {
      this.MontoIva = 0;
    }
    if (!this.MontoAf) {
      this.MontoAf = 0;
    }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  onProductSeleccionado(data) {
    this.productoSeleccionado = null;
    this.productoSeleccionado = data;
    this.PrecioUni = 0;

    this.totalLine = 0;
    this.formItems.get('productoExistente.codCantidad').setValue(1);
    this.formItems.get('productoExistente.codProduct').setValue(this.productoSeleccionado.producto_proveedor);
    this.formItems.get('productoExistente.formatCode').setValue(this.productoSeleccionado.formato_codigo);

    this.fetchPrecioCosto(data);
  }

  private fetchPrecioCosto(producto) {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        producto_codigo: producto.producto_codigo,
        formato_codigo: producto.formato_codigo_top,
      },
    };

    this.log('fetch monto IVA', JSON.stringify(inputParams));
    this.listaPrecioDetalleService.obtenerPrecioCosto(inputParams, ({ respuesta }) => {
      if (respuesta != null) {
        const precioCosto = respuesta.precio_costo;
        this.PrecioUni = precioCosto;
        // this.formItems.get('productoExistente.codPrecioU').setValue(precioCosto);
        this.totalLine = precioCosto;
        if (precioCosto === 0) {
          this.formItems.get('productoExistente.codCantidad').setValue(0);
        }
        this.searchTotalLinea(this.ImpuestoCod, this.cantidadRecibida, this.PrecioUni, this.descuentoCod, this.RecargoCod);
      }
    });
  }

  // VALIDACION CAMPOS EN FALSO
  OnChangeFolio(folio) {
    if (folio == 0) {
      this.EnableButton = false;
    }

    if (folio == '') {
      this.EnableButton = false;
    }

    if (folio == null) {
      this.EnableButton = false;
    }

    this.Existefolio = folio;
  }

  searchByFolio(Folio: number, tipodteCodigo: number, proveedor: number) {
    let lastFolio: number = 0;
    // Query Local
    if (this.Existefolio == '' || this.Existefolio == null) {
      this.EnableButton = false;
    } else {
      if (lastFolio !== Folio) {
        lastFolio = Folio;

        const inputParams = {
          entidad: {
            rut_receptor: this.rutEmpresa,
            sucursal_codigo: this.sucursalCodigo,
            rut_emisor: this.rutService.QuitarDV(proveedor),
            tipo_dte_codigo: tipodteCodigo,
            folio: lastFolio,
          },
        };

        this.documentoRecepcionadoService.existeFolio(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            this.loading = false;
            return;
          }

          if (respuesta === true) {
            this.messageRendererService.showInfoMessages(mensajes);
            this.formHeader.get('nFolio').setValue(null);
            return;
          }

          // Retorna false, se puede usar
          if (respuesta === false) {
            this.EnableButton = true;
          }
        });
      }
    }
  }

  OnChangeRutProveedor(rutproveedor) {
    this.formHeader.get('rutProveedor').setValue(rutproveedor);
    this.EnableItemAndSave();
  }

  EnableItemAndSave() {
    const rutProveedor = this.formHeader.get('rutProveedor').value;

    if (rutProveedor != '' && rutProveedor != null && this.folio > 0) {
      const tipodte_codigo = this.formHeader.get('tipoFact').value;

      this.searchByFolio(this.folio, tipodte_codigo, rutProveedor);
    } else {
      if (this.formHeader.get('nFolio').value == '') {
        this.EnableButton = false;
      }

      if (this.formHeader.get('nFolio').value == 0) {
        this.EnableButton = false;
      }

      if (!this.folio && rutProveedor != '' && rutProveedor != null) {
        this.EnableButton = false;
      }

      if (rutProveedor === '') {
        this.EnableButton = false;
        this.proveedorSeleccionado.nombre = null;
      }

      if (rutProveedor === null) {
        this.EnableButton = false;
        this.proveedorSeleccionado = null;
      }
    }
  }

  onProductoNoEncontrado() {
    this.clearProductoSeleccionadoData();
  }

  clearProductoSeleccionadoData() {
    this.productoSeleccionado = null;
  }

  // input Precio
  onChangePrecioU(precio) {
    this.priceU = parseInt(precio);

    if (precio === '') {
      this.priceU = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    this.searchTotalLinea(tax, amount, this.PrecioUni, discount, surchage);
  }

  // input Cantidad
  onChangeAmount(cantidad) {
    if (cantidad === '') {
      this.amountInput = 0;
    } else {
      this.amountInput = parseInt(cantidad);
      if (this.amountInput > 0) {
        this.amountInput = parseInt(cantidad);
      }
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    if (this.PrecioUni > 0) {
      this.searchTotalLinea(tax, this.amountInput, this.PrecioUni, discount, surchage);
    }
  }

  // NotificarNoexisteFolio(folio){
  //   if(this.NoExisteFolio == false && (folio === null || folio === ''))
  //     this.toastService.error("No existen folio");

  //   if(folio == null || folio == '')
  //     this.NoExisteFolio = true;
  //   else
  //     this.NoExisteFolio = false;

  // }

  // input Descuento
  onChangeDiscount(descuento) {
    this.inputDiscount = parseInt(descuento);

    if (descuento === '') {
      this.inputDiscount = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    this.searchTotalLinea(tax, amount, price, this.inputDiscount, surchage);
  }

  // input Recargo
  onChangeSurcharge(recargo) {
    this.inputSurcharge = parseInt(recargo);

    if (recargo === '') {
      this.inputSurcharge = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    this.searchTotalLinea(tax, amount, price, discount, this.inputSurcharge);
  }

  // input Impuesto
  onChangeTax(impuesto) {
    this.taxInput = parseInt(impuesto.codigo);

    if (!impuesto.codigo) {
      this.taxInput = 0;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    this.searchTotalLinea(this.taxInput, amount, price, discount, surchage);
  }

  openModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }
  private limpiarDataSeleccionada() {
    this.headerData = {};
  }

  onProveedorSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada();
    this.headerData = {};
    this.headerData.proveedorSeleccionado = data;
    this.headerData.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.headerData.proveedorSeleccionado.rut);
    this.proveedorSeleccionado = data;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
    this.seleccionaRutProveedor = this.proveedorSeleccionado.rut;

    this.EnableItemAndSave();
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado);
    this.fetchSucursal(this.headerData.proveedorSeleccionado.rut);
    console.log('PROVEEDOR SELECCIONADO ', data);
  }

  private handleFechaFacturaChange(fecha) {
    this.headerData.fechaVencimiento = null;
    if (!fecha)
      // TODO Validar que sea fecha válida
      return;
    this.fetchFechaVencimiento();
  }

  private fetchFechaVencimiento() {
    this.headerData.fechaVencimiento = null;
    this.log('fetchFechaVencimiento', this.formHeader.get('FechaDoc').value, this.formHeader.get('CondPago').value, this.headerData);
    if (
      !this.headerData ||
      // !this.headerData.clienteSeleccionado ||
      // !this.headerData.direccion ||
      !this.formHeader.get('FechaDoc').value ||
      !this.formHeader.get('CondPago').value
    )
      return;

    const inputParams: IFechaVencimientoQueryParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      cliente_proveedor_rut: 0,
      // direccion_codigo: this.headerData.clienteSeleccionado.codigo_direccion,
      direccion_codigo: 0,
      fecha_documento: this.formHeader.get('FechaDoc').value,
      condicion_pago_codigo: this.formHeader.get('CondPago').value,
    };

    this.log('fetchFechaVencimiento', JSON.stringify(inputParams));
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      this.headerData.fechaVencimiento = respuesta.fecha_vencimiento;
    });
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;
    this.EnableButton = false;
    this.clearProveeData();
  }
  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }

  clearContent() {
    this.headerData = {};
    this.formValidatorsService.reset(this.formHeader);
  }

  searchTotalLinea(tax, amount, price, discount, surcharge) {
    const inputParams = {
      entidad: {
        tipo_item_codigo: this.formItems.get('productoExistente.tipoItems').value,
        equivalencia_producto_id: this.productoSeleccionado.id,
        producto_proveedor: this.productoSeleccionado.producto_proveedor,
        producto_proveedor_descripcion: this.productoSeleccionado.detalle_producto,
        formato_codigo: this.productoSeleccionado.formato_codigo,
        factor_equivalencia: this.productoSeleccionado.factor_equivalencia,
        producto_codigo: this.productoSeleccionado.producto_codigo,
        sku: this.productoSeleccionado.producto_sku,
        producto_descripcion: this.productoSeleccionado.producto_descripcion,
        formato_codigo_top: this.productoSeleccionado.formato_codigo_top,
        formato_nombre_top: this.productoSeleccionado.formato_descripcion_top,
        cantidad_recibida: amount,
        precio_unitario: this.PrecioUni,
        desc_es_porcentaje: this.formItems.get('productoExistente.tipoDesc').value,
        descuento: parseInt(discount),
        rec_es_porcentaje: this.formItems.get('productoExistente.tipoRec').value,
        recargo: parseInt(surcharge),
        es_activo_fijo: this.formItems.get('productoExistente.ActivoFijo').value,
        impuesto_codigo: tax,
      },
    };
    this.currentSearchParams = inputParams.entidad;

    this.documentoRecepcionadoService.obtenerTotalLinea(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.listaDetalleDoc = respuesta;

      this.totalLine = respuesta.total_linea;
      this.detalleNombreItem = respuesta.tipo_item_nombre;
    });
  }

  private validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  AddDetalle() {
    const folio = this.formHeader.get('nFolio').value;

    if (folio === null || folio === '') {
      this.NoExisteFolio = true;
      if (this.NoExisteFolio === true) {
        this.toastService.warning('Ingrese Folio');
        return;
      }
    } else {
      this.NoExisteFolio = false;
    }

    this.detalleItem = _.cloneDeep(this.currentSearchParams);
    if (this.AddlistaDetalleDocRec.length == 0) {
      this.AddlistaDetalleDocRec = [];
    } else {
      this.AddlistaDetalleDocRec;
    }

    this.validateAllFormFields(this.formItems);

    if (this.formItems.get('productoExistente.codCantidad').value === 0) {
      this.toastService.error('Ingrese la cantidad de productos');
      return;
    }

    if (this.formItems.get('productoExistente.codCantidad').value > 0 && this.formItems.get('productoExistente.codPrecioU').value > 0) {
      const inputParams = {
        entidad: {
          rut_receptor: this.rutEmpresa,
          rut_emisor: this.rutService.QuitarDV(this.formHeader.get('rutProveedor').value),
          tipo_dte_codigo: this.formHeader.get('tipoFact').value,
          folio: this.formHeader.get('nFolio').value,
        },
        detalle: {
          tipo_item_codigo: this.detalleItem.tipo_item_codigo,
          tipo_item_nombre: this.detalleNombreItem,
          producto_proveedor: this.formItems.get('productoExistente.codProduct').value,
          producto_proveedor_descripcion: this.detalleItem.producto_proveedor_descripcion,
          formato_codigo: this.detalleItem.formato_codigo,
          factor_equivalencia: this.detalleItem.factor_equivalencia,
          producto_codigo: this.detalleItem.producto_codigo,
          sku: this.detalleItem.sku,
          equivalencia_producto_id: this.detalleItem.equivalencia_producto_id,
          producto_descripcion: this.detalleItem.producto_descripcion,
          formato_codigo_top: this.detalleItem.formato_codigo_top,
          formato_nombre_top: this.detalleItem.formato_nombre_top,
          cantidad_recibida: this.formItems.get('productoExistente.codCantidad').value,
          precio_unitario: this.formItems.get('productoExistente.codPrecioU').value,
          desc_es_porcentaje: this.formItems.get('productoExistente.tipoDesc').value,
          descuento: this.formItems.get('productoExistente.codDescuento').value,
          rec_es_porcentaje: this.formItems.get('productoExistente.tipoRec').value,
          recargo: this.formItems.get('productoExistente.codRecargo').value,
          es_activo_fijo: this.formItems.get('productoExistente.ActivoFijo').value,
          impuesto_codigo: this.detalleItem.impuesto_codigo,
          listaDetalle: this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
        },
        paginaActual: this.paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: 20,
      };
      this.log('inputParams', JSON.stringify(inputParams));

      this.loading = true;

      this.documentoRecepcionadoDetalleService.agregaDetalleProductoRecepcionado(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.loading = false;
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        this.paginationContext.RecordsCount = totalRegistros;
        this.paginationContext.CurrentPage = paginaActual;
        this.paginationContext.PagesCount = totalPaginas;

        this.AddlistaDetalleDocRec = registros;

        this.AddlistaDetalleDocRec.forEach((mov, index) => {
          mov.additionalInfo = {};
          mov.additionalInfo.index = index;
          mov.additionalInfo.checked = false;
        });

        this.totalMonto = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
        this.SubTotal = this.totalMonto;
        if (registros.length === 0) {
          this.loading = false;
        }

        this.ClearFiltrosFormItems();
      });
    } else {
      return;
    }
  }

  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach((val) => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map((p) => {
      if (cleanCheck) delete p.__typename;
      delete p.additionalInfo;
    });
    return _detalledocumento;
  }

  checkAllChangeDetalle({ checked }) {
    this.AddlistaDetalleDocRec.forEach((detalle) => {
      detalle.additionalInfo.checked = checked;
    });

    //SELECCIONAR TODO
    this.checkAllDetalle = checked;

    //ELEMENTOS SELECCIONADOS
    this.countSelectDetalle = this.AddlistaDetalleDocRec.filter((x) => x.additionalInfo.checked === true).length;
  }

  checkDetalleList({ index }, { checked }) {
    this.AddlistaDetalleDocRec.map((detalle) => {
      if (detalle.additionalInfo.index === index) {
        detalle.additionalInfo.checked = checked;
      }
    });

    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.AddlistaDetalleDocRec.filter((detalle: any) => !detalle.additionalInfo.checked).length;
    this.checkAllDetalle = totalUnselected === 0;

    //SUMA DE ELEMENTOS SELECCIONADOS
    this.countSelectDetalle = this.AddlistaDetalleDocRec.filter((x) => x.additionalInfo.checked === true).length;
  }

  DeleteDetalle() {
    var atleastOneSelected = this.AddlistaDetalleDocRec.filter((checkbox) => checkbox.additionalInfo.checked === true);

    if (atleastOneSelected.length === 0) {
      this.countSelectDetalle = 0;
      this.toastService.error('No existen registros para eliminar');
      return;
    }

    var UnSelectData = this.AddlistaDetalleDocRec.filter((checkbox) => checkbox.additionalInfo.checked === false);
    this.AddlistaDetalleDocRec = UnSelectData;

    if (this.checkAllDetalle === true) {
      this.countSelectDetalle = 0;
      this.loading = false;
    }

    this.checkAllDetalle = false;
    this.totalMonto = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
    this.SubTotal = this.totalMonto;

    this.ClearFiltrosFormItems();
  }

  ClearFiltrosFormItems() {
    //LIMPIAR FILTROS de FORMITEMS
    this.formValidatorsService.reset(this.formItems);
    this.priceU = 0;
    this.amountInput = 0;
    this.inputDiscount = 0;
    this.inputSurcharge = 0;
    this.taxInput = 0;
    this.totalLine = 0;
    this.productoSeleccionado = null;
    this.formItems.get('productoExistente.tipoItems').setValue(1);
    this.formItems.get('productoExistente.codProduct').setValue(null);

    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.formItems.get('productoLibre.formato').setValue('UNID');
    this.formItems.get('productoLibre.cantidad').setValue('1');
    this.formItems.get('productoLibre.es_exento').setValue(this.PRODUCTO_LIBRE_AFECTO);
    this.detalleItem = null;
  }

  CloseDocRecManualmente() {
    //limpiar Filtros
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formItems.reset(this.formItems);
    this.formValidatorsService.reset(this.formHeader);
    this.formValidatorsService.reset(this.formImpuestos);

    this.formHeader.get('mesPeriodo').setValue(this.initialValues.mesPeriodo);
    this.formHeader.get('gestion').setValue(this.initialValues.gestion);
    this.formHeader.get('tipoFact').setValue(33);
    this.formHeader.get('FechaDoc').setValue(currentDate);
    // this.formHeader.get('CondPago').setValue(1);
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('CondPago'), this.optionsCondPago);

    this.formHeader.get('MueveInventario').setValue(true);
    this.formHeader.get('bodega').setValue(1);

    this.folio = null;
    this.SubTotal = 0;
    this.MontoAf = 0;
    this.MontoEx = 0;
    this.DescGbl = 0;
    this.RecargoGbl = 0;
    this.MontoIva = 0;
    this.IvaRec = 0;
    this.IvaNoRec = 0;
    this.IvaActF = 0;
    this.IvaRet = 0;
    this.IvaComn = 0;
    this.TotalBruto = 0;

    this.formItems.get('productoExistente.tipoItems').setValue(1);
    this.formItems.get('productoExistente.codProduct').setValue(null);
    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.formItems.get('productoLibre.formato').setValue('UNID');
    this.formItems.get('productoLibre.cantidad').setValue(1);
    this.formItems.get('productoLibre.es_exento').setValue(this.PRODUCTO_LIBRE_AFECTO);

    this.formItems.get('productoLibre.codigo').setValue(null);
    this.formItems.get('productoLibre.descripcion').setValue(null);
    this.formItems.get('productoLibre.precioUnitario').setValue(null);

    this.impuesto = '';
    this.showBodega = true;
    this.priceU = 0;
    this.amountInput = 0;
    this.inputDiscount = 0;
    this.inputSurcharge = 0;
    this.taxInput = 0;
    this.totalLine = 0;
    this.productoSeleccionado = null;
    this.detalleItem = null;
    this.totalMonto = 0;
    this.proveedorSeleccionado = null;
    this.AddlistaDetalleDocRec = [];
    this.listaDetalleDoc = [];
    this.EnableButton = false;
    this.loading = false;
    this.agregarDocModal.hide();
  }

  saveDocRecManualmente() {
    if (!this.formHeader.valid) {
      this.toastService.warning('Favor complete los datos requeridos');
      return;
    }

    const inputParams: any = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        mes: this.formHeader.get('mesPeriodo').value,
        anno: this.formHeader.get('gestion').value,
        rut_emisor: this.rutService.QuitarDV(this.formHeader.get('rutProveedor').value),
        tipo_dte_codigo: this.formHeader.get('tipoFact').value,
        folio: this.formHeader.get('nFolio').value,
        rut_usuario_recepcion: this.rut_usuario, //rut persona registrada
        fecha_recepcion: this.formHeader.get('FechaDoc').value,
        fecha_vencimiento: this.headerData.fechaVencimiento,
        condicion_pago_codigo: this.formHeader.get('CondPago').value,
        glosa_nominal: this.formHeader.get('GlosaN').value,
        es_entrega_gratuita: this.formHeader.get('EntregaGratuita').value,
        monto_detalle_bruto: this.formHeader.get('MontoBrutoDetalle').value,
        mueve_inv: this.formHeader.get('MueveInventario').value,
        bodega_codigo: this.formHeader.get('bodega').value,
        facto_iva_uso_comun: this.formHeader.get('FactorIva').value,
        monto_imp_adic: this.montoImpuestoAdicional,
        monto_subtotal: this.SubTotal,
        monto_descuento: this.DescGbl,
        monto_recargo: this.RecargoGbl,
        monto_afecto: this.MontoAf,
        monto_exento: this.MontoEx,
        monto_iva: this.MontoIva,
        monto_total: this.TotalBruto,
        iva_recuperable: this.IvaRec,
        iva_no_recuperable: this.IvaNoRec,
        iva_activo_fijo: this.IvaActF,
        iva_retenido: this.IvaRet,
        iva_comun: this.IvaComn,
        listaDetalle: this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoRecepcionadoService.guardarFacturaRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = true;
        return;
      }

      this.toastService.success('Operación realizada con éxito');
      this.CloseDocRecManualmente();
      this.BuscarItems();
    });
  }

  BuscarItems() {
    this.onExecuteBuscar.emit(1);
  }

  private handleDireccionChange(value) {
    this.log('handleDireccionChange', value);
    if (!this.headerData || !this.headerData.proveedorSeleccionado) return;

    this.headerData.direccion = value.direccion;
    const condicionPagoSucursal = this.optionsCondPago.filter((p) => p.codigo === this.headerData.direccion.condicion_pago_codigo);
    if (condicionPagoSucursal && condicionPagoSucursal.length > 0) {
      this.formHeader.get('CondPago').setValue(condicionPagoSucursal[0].value);
      this.fetchFechaVencimiento();
    } else {
      this.formHeader.get('CondPago').setValue(1);
      this.fetchFechaVencimiento();
    }
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          // sucursal_codigo: this.sucursalEmpresa,
          rut: this.rutService.QuitarDV(cliente_proveedor_rut),
        },
      },
    };

    this.log('fetch sucursal', JSON.stringify(inputParams));
    this.clienteProveedorService.ObtenerProveedorEspecifico(inputParams, ({ respuesta }) => {
      const direccion = respuesta;
      this.handleDireccionChange(direccion);
    });
  }

  private fetchMontoIVA(montoAfecto: number) {
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        monto_afecto: montoAfecto,
      },
    };

    this.log('fetch monto IVA', JSON.stringify(inputParams));
    this.documentoRecepcionadoService.obtenerMontoImpuesto(inputParams, ({ respuesta }) => {
      const montoIVA = respuesta;
      this.MontoIva = montoIVA;
      this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
    });
  }

  public AddDetalleSinSKU() {
    this.detalleItem = _.cloneDeep(this.currentSearchParams);

    const folio = this.formHeader.get('nFolio').value;
    const proveedor = this.formHeader.get('rutProveedor').value;
    if (folio === null || folio === '') {
      this.NoExisteFolio = true;
      if (this.NoExisteFolio === true) {
        this.toastService.warning('Ingrese Folio');
        return;
      }
    } else {
      this.NoExisteFolio = false;

      if (proveedor === null || proveedor === '') {
        this.toastService.warning('Ingrese el rut de proveedor');
        this.noExisteProveedor = true;
        return;
      } else {
        this.noExisteProveedor = false;
      }
    }

    if (this.AddlistaDetalleDocRec.length == 0) {
      this.AddlistaDetalleDocRec = [];
    } else {
      this.AddlistaDetalleDocRec;
    }

    //Ocultar mueve inventario y colocarlo en false
    this.formHeader.get('MueveInventario').setValue(false);

    this.log('DETALLE 2', this.formHeader.get('tipoFact').value);
    this.validateAllFormFields(this.formItems);

    if (this.formItems.get('productoLibre.cantidad').value > 0 && this.formItems.get('productoLibre.precioUnitario').value > 0) {
      const { rutProveedor, tipoFact, nFolio } = this.formHeader.value;
      const inputParams = {
        entidad: {
          rut_receptor: this.rutEmpresa,
          rut_emisor: this.rutService.QuitarDV(rutProveedor),
          tipo_dte_codigo: tipoFact,
          folio: nFolio,
        },
        detalle: {
          tipo_item_codigo: this.formItems.get('productoLibre.es_exento').value === this.PRODUCTO_LIBRE_AFECTO ? 1 : 2,
          tipo_item_nombre: this.formItems.get('productoLibre.es_exento').value === this.PRODUCTO_LIBRE_AFECTO ? 'AFECTO' : 'EXENTO',
          producto_proveedor: this.formItems.get('productoLibre.codigo').value === null ? '0' : this.formItems.get('productoLibre.codigo').value,
          producto_proveedor_descripcion: this.formItems.get('productoLibre.descripcion').value,
          formato_codigo: this.formItems.get('productoLibre.formato').value,
          factor_equivalencia: 0,
          producto_codigo: 0,
          sku: '',
          equivalencia_producto_id: 0,
          producto_descripcion: '',
          formato_codigo_top: '',
          formato_nombre_top: '',
          cantidad_recibida: this.formItems.get('productoLibre.cantidad').value,
          precio_unitario: this.formItems.get('productoLibre.precioUnitario').value,
          desc_es_porcentaje: false,
          descuento: 0,
          rec_es_porcentaje: false,
          recargo: 0,
          es_activo_fijo: false,
          impuesto_codigo: 0,
          listaDetalle: this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
        },
        paginaActual: this.paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: 20,
      };
      this.log('inputParams', JSON.stringify(inputParams));

      this.loading = true;

      this.documentoRecepcionadoDetalleService.agregaDetalleProductoSinSKURecepcionado(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.loading = false;
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        this.paginationContext.RecordsCount = totalRegistros;
        this.paginationContext.CurrentPage = paginaActual;
        this.paginationContext.PagesCount = totalPaginas;

        this.AddlistaDetalleDocRec = registros;

        this.AddlistaDetalleDocRec.forEach((mov, index) => {
          mov.additionalInfo = {};
          mov.additionalInfo.index = index;
          mov.additionalInfo.checked = false;
        });

        this.totalMonto = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
        this.SubTotal = this.totalMonto;
        if (registros.length === 0) {
          this.loading = false;
        }

        this.ClearFiltrosFormItems();
      });
    } else {
      return;
    }
  }
}
